import type { ReactNode } from "react";
import type { Session } from "@cs2/contracts/transport";
import { AppShell } from "./AppShell.js";

export function PageState({
  active,
  session,
  children,
}: {
  active: "quickview" | "editor" | "catalog";
  session: Session | null;
  children: ReactNode;
}) {
  return (
    <AppShell active={active} session={session} onboarding={false}>
      <main className="app-page-state" role="status">
        {children}
      </main>
    </AppShell>
  );
}
